import cache from "utils/cache";

const AuthService = {
  isAuthenticated: () => {
    return !!cache.getItem("user");
  },
  getUser: () => {
    return cache.getItem("user");
  },
};

export default AuthService;
